import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetFlowNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetFlowNameResult extends IResult {
}

export class SetFlowNameRequest extends Request<SetFlowNameParams, SetFlowNameResult> {
  constructor(params: SetFlowNameParams) {
    super('setFlowName', params);
  }
}
